import { toast } from "sonner";
import { getClientTolgee } from "#/integrations/tolgee/tolgee-instance.ts";

const TOAST_ID = "chart-ws-stale";

export function notifyChartRealtimeStale() {
	toast.warning(
		getClientTolgee().t({
			key: "toast.chart-realtime-stale",
			defaultValue:
				"Real-time chart updates paused. Refresh the page to retry.",
		}),
		{ id: TOAST_ID, duration: 6000 },
	);
}
